import React from 'react';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Services } from '../components/Services';
import { HumanImpact } from '../components/HumanImpact';
import { ImpactStats } from '../components/ImpactStats';
import { HowItWorks } from '../components/HowItWorks';
import { WhyArissa } from '../components/WhyArissa';
import { Industries } from '../components/Industries';
import { RecoveryStories } from '../components/RecoveryStories';
import { Testimonials } from '../components/Testimonials';
import { Insights } from '../components/Insights';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <>
      <Hero data-id="element-719" />
      <TrustBar data-id="element-720" />
      <Services data-id="element-721" />
      <HumanImpact data-id="element-722" />
      <ImpactStats data-id="element-723" />
      <HowItWorks data-id="element-724" />
      <WhyArissa data-id="element-725" />
      <Industries data-id="element-726" />
      <RecoveryStories data-id="element-727" />
      <Testimonials data-id="element-728" />
      <Insights data-id="element-729" />
      <FAQ data-id="element-730" />
      <CTASection data-id="element-731" />
    </>;
}